export enum Keys {
  backspace = 'Backspace',
  delete = 'Delete',
  enter = 'Enter',
  escape = 'Escape',
}
